import { FullUserFragment } from "graphql.generated";
import { JobRole } from "src/app/global.constants";

export const jobAgentInitialState = {
  employeeSearch: {} as Record<JobRole, string>,
  employeeSuggestions: [] as FullUserFragment[],
  isEditRole: {} as Record<JobRole, true>,
  selectedEmployees: {} as Record<JobRole, FullUserFragment>
} as const;
